import { ReportPage } from "../views/Reports/ReportExpenses/ReportPage";
import { LogsReportPage } from "../views/LogsReports/LogsReportPage";
import { ReportAdvancePaymentsView } from "views/Reports/ReportAdvancePayments/ReportAdvancePaymentsView";
import { ReportAuditSettlementsView } from "views/Reports/ReportAuditSettlements/ReportAuditSettlementsView";
import { ReportSettlementsView } from "views/Reports/ReportSettlements/ReportSettlementsView";
import { ReportCashDiscountCustomersView } from "views/Reports/ReportCashDiscountCustomers/ReportCashDiscountCustomersView";
import { ReportSupervisionView } from "views/Reports/ReportSupervision/ReportSupervisionView";
import { ReportCarburetionView } from "views/Reports/ReportCarburetion/ReportCarburetionView";
import { ReportCarburetion3View } from "views/Reports/ReportCarburetion3/ReportCarburetion3View";
import { ReportInventoriesView } from "views/Reports/ReportInventories/ReportInventoriesView";
import { ReportInventoriesDayView } from "views/Reports/ReportInventories/ReportInventoriesDayView";
import { ReportInventoryStockView } from "views/Reports/ReportInventoryStock/ReportInventoryStockView";
import { ReportDayView } from "views/Reports/ReportDay/ReportDayView";
import { ReportGasMovementsView } from "views/Reports/ReportGasMovements/ReportGasMovementsView";
import { ReportSalesView } from "views/Reports/ReportSales/ReportSalesView";
import { ReportSalesUnitView } from "views/Reports/ReportSales/ReportSalesUnitView";
import { ReportSalesCustomerView } from "views/Reports/ReportSalesCustomer/ReportSalesCustomerView";
import { ReportCreditView } from "views/Reports/ReportCredit/ReportCreditView";
import { ReportNotesTransferredView } from "views/Reports/ReportNotesTransferred/ReportNotesTransferredView";
import { ReportCorporateShipmentsView } from "views/Reports/ReportCorporateShipments/ReportCorporateShipmentsView";
import { ReportShipmentsPerformanceView } from "views/Reports/ReportShipmentsPerformance/ReportShipmentsPerformanceView";
import { ReportComoDataView } from "views/Reports/ReportComoData/ReportComoDataView";
import { ReportResumeDayView } from "views/Reports/ReportResumeDay/ReportResumeDayView";
import { ReportDepositsView } from "views/Reports/ReportDeposits/ReportDepositsView";
import { ReportInvoiceListView } from "views/Reports/ReportInvoiceList/ReportInvoiceListView";
import { ReportInvoiceRelationshipView } from "views/Reports/ReportInvoiceRelationship/ReportInvoiceRelationshipView";
import { ReportTransferInvoiceView } from "views/Reports/ReportTransferInvoice/ReportTransferInvoiceView";
import { ReportGlobalSalesView } from "views/Reports/ReportGlobalSales/ReportGlobalSales";
import { ReportSalesCategoryView } from "views/Reports/ReportSalesCategory/ReportSalesCategoryView";
import { ReportCashReconciliationView } from "views/Reports/ReportCashReconciliation/ReportCashReconciliationView";
import { ReportDigitalInventoryView } from "views/Reports/ReportDigitalInventory/ReportDigitalInventoryView";
import { ReportSalesCumulativeGlobalView } from "views/Reports/ReportSalesCumulativeGlobal/ReportSalesCumulativeGlobalView";
import { ReportSalesByNoteView } from "views/Reports/ReportSalesByNote/ReportSalesByNoteView";
import { ReportSalesByZoneWholesalerView } from "views/Reports/ReportSalesByZoneWholesaler/ReportSalesByZoneWholesalerView";
import { ReportNationalNotesView } from "views/Reports/ReportNationalNotes/ReportNationalNotesView";
import { ReportDiscountsRelationshipView } from "views/Reports/ReportDiscountsRelationship/ReportDiscountsRelationshipView";
import { ReportSaleByMunicipalityView } from "views/Reports/ReportSaleByMunicipality/ReportSaleByMunicipalityView";
import { ReportRapidCanvasView } from "views/Reports/ReportRapidCanvas/ReportRapidCanvasView";
import { ReportDetailedNotesView } from "views/Reports/ReportDetailedNotes/ReportDetailedNotesView";
import { ReportSubstitutionSettlementsView } from "views/Reports/ReportSubstitutionSettlements/ReportSubstitutionSettlementsView";
import { ReportRetentionsView } from "views/Reports/ReportRetentions/ReportRetentionsView";
import { ReportRetentionsExistsView } from "views/Reports/ReportRetentionsExists/ReportRetentionsExistsView";
import { ReportSpecialUnitsView } from "views/Reports/ReportSpecialUnits/ReportSpecialUnitsView";
import { ReportShipmentsReturnsView } from "views/Reports/ReportShipmentsReturns/ReportShipmentsReturnsView";
import { ReportUnitPerformanceView } from "views/Reports/ReportUnitPerformance/ReportUnitPerformanceView";
import { ReportUnitsWithPermissionView } from "views/Reports/ReportUnitsWithPermission/ReportUnitsWithPermissionView";
import { ReportAccumulatedDiscountView } from "views/Reports/ReportAccumulatedDiscount/ReportAccumulatedDiscountView";
import { ReportProgressiveAppView } from "views/Reports/ReportProgressiveApp/ReportProgressiveAppView";
import { ReportInventoryPercentagesView } from "views/Reports/ReportInventoryPercentages/ReportInventoryPercentagesView";
import { ReportInvoicesGroupedView } from "views/Reports/ReportInvoicesGrouped/ReportInvoicesGroupedView";

import AssessmentIcon from "@material-ui/icons/Assessment";

import { reportAdvancePaymentsTypes } from "redux/reducers/Reports/reportAdvancePayments/types";
import { reportAuditSettlementsTypes } from "redux/reducers/Reports/reportAuditSettlements/types";
import { reportSettlementsTypes } from "redux/reducers/Reports/reportSettlements/types";
import { reportCashDiscountCustomersTypes } from "redux/reducers/Reports/reportCashDiscountCustomers/types";
import { reportCarburetionTypes } from "redux/reducers/Reports/reportCarburetion/types";
import { reportCarburetion3Types } from "redux/reducers/Reports/reportCarburetion3/types";
import { reportComoDataTypes } from "redux/reducers/Reports/reportComoData/types";
import { reportDayTypes } from "redux/reducers/Reports/reportDay/types";
import { reportGasMovementsTypes } from "redux/reducers/Reports/reportGasMovements/types";
import { reportInventoriesTypes } from "redux/reducers/Reports/reportInventories/types";
import { reportSalesTypes } from "redux/reducers/Reports/reportSales/types";
import { reportSalesCustomerTypes } from "redux/reducers/Reports/reportSalesCustomer/types";
import { reportSupervisionTypes } from "redux/reducers/Reports/reportSupervision/types";
import { reportResumeDayTypes } from "redux/reducers/Reports/reportResumeDay/types";
import { reportDepositsTypes } from "redux/reducers/Reports/reportDeposits/types";
import { reportInventoryStockTypes } from "redux/reducers/Reports/reportInventoryStock/types";
import { reportInvoiceListTypes } from "redux/reducers/Reports/reportInvoiceList/types";
import { reportInvoiceRelationshipTypes } from "redux/reducers/Reports/reportInvoiceRelationship/types";
import { reportTransferInvoiceTypes } from "redux/reducers/Reports/reportTransferInvoice/types";
import { reportGlobalSalesTypes } from "redux/reducers/Reports/reportGlobalSales/types";
import { reportSalesCategoryTypes } from "redux/reducers/Reports/reportSalesCategory/types";
import { reportCashReconciliationTypes } from "redux/reducers/Reports/reportCashReconciliation/types";
import { reportDigitalInventoryTypes } from "redux/reducers/Reports/reportDigitalInventory/types";
import { reportSalesCumulativeGlobalTypes } from "redux/reducers/Reports/reportSalesCumulativeGlobal/types";
import { reportSalesByNoteTypes } from "redux/reducers/Reports/reportSalesByNote/types";
import { reportSalesByZoneWholesalerTypes } from "redux/reducers/Reports/reportSalesByZoneWholesaler/types";
import { reportNationalNotesTypes } from "redux/reducers/Reports/reportNationalNotes/types";
import { reportDiscountsRelationshipTypes } from "redux/reducers/Reports/reportDiscountsRelationship/types";
import { reportSaleByMunicipalityTypes } from "redux/reducers/Reports/reportSaleByMunicipality/types";
import { reportShipmentsPerformanceTypes } from "redux/reducers/Reports/reportShipmentsPerformance/types";
import { reportDetailedNotesTypes } from "redux/reducers/Reports/reportDetailedNotes/types";
import { reportSubstitutionSettlementsTypes } from "redux/reducers/Reports/reportSubstitutionSettlements/types";
import { reportRetentionsTypes } from "redux/reducers/Reports/reportRetentions/types";
import { reportRetentionsExistsTypes } from "redux/reducers/Reports/reportRetentionsExists/types";
import { reportSpecialUnitsTypes } from "redux/reducers/Reports/reportSpecialUnits/types";
import { reportShipmentsReturnsTypes } from "redux/reducers/Reports/reportShipmentsReturns/types";
import { reportUnitPerformanceTypes } from "redux/reducers/Reports/reportUnitPerformance/types";
import { reportUnitsWithPermissionTypes } from "redux/reducers/Reports/reportUnitsWithPermission/types";
import { reportAccumulatedDiscountTypes } from "redux/reducers/Reports/reportAccumulatedDiscount/types";
import { reportProgressiveAppTypes } from "redux/reducers/Reports/reportProgressiveApp/types";
import { reportInventoryPercentagesTypes } from "redux/reducers/Reports/reportInventoryPercentages/types";
import { reportInvoicesGroupedTypes } from "redux/reducers/Reports/reportInvoicesGrouped/types";

import { PERMISSIONS } from "router/permissions";

const {
  REPORTS,
  REPORTS_EXPENSES,
  REPORTS_LOGINS,
  REPORTS_DAY_GN4,
  REPORTS_DETAIL_INVENTORY,
  REPORTS_INVENTORY,
  REPORTS_CARBURATION,
  REPORTS_GLOBAL_SALES,
  REPORTS_SUPERVISION,
  REPORTS_BONIFICATIONS,
  REPORTS_SALES,
  REPORTS_SALES_CUSTOMER,
  REPORTS_SHIPMENTS,
  REPORTS_COMODATA,
  REPORTS_CREDIT,
  REPORTS_CREDIT_MIGRATION,
  REPORTS_RESUME_DAY,
  REPORTS_DEPOSITS,
  REPORTS_INVOICE_LIST,
  REPORTS_INVOICE_RELATIONSHIP,
  REPORTS_SALES_CATEGORY,
  REPORTS_CASH_RECONCILIATION,
  REPORTS_SALES_CUMULATIVE_GLOBAL,
  REPORTS_SALES_BY_NOTE,
  REPORTS_NATIONAL_NOTES,
  REPORTS_DIGITAL_INVENTORY,
  REPORTS_RAPIDCANVAS,
} = PERMISSIONS

const repCarburetionErrorConfig = {
  reducer: "reportCarburetion",
  restoreKey: reportCarburetionTypes.RESTORE_INITIAL
}
const repComoDataErrorConfig = {
  reducer: "reportComoData",
  restoreKey: reportComoDataTypes.RESTORE_INITIAL
}
const repDayErrorConfig = {
  reducer: "reportDay",
  restoreKey: reportDayTypes.RESTORE_INITIAL
}
const repGasMovementsErrorConfig = {
  reducer: "reportGasMovements",
  restoreKey: reportGasMovementsTypes.RESTORE_INITIAL
}
const repInventoriesErrorConfig = {
  reducer: "reportInventories",
  restoreKey: reportInventoriesTypes.RESTORE_INITIAL
}
const repSalesErrorConfig = {
  reducer: "reportSales",
  restoreKey: reportSalesTypes.RESTORE_INITIAL
}
const repSalesCustomerErrorConfig = {
  reducer: "reportSalesCustomer",
  restoreKey: reportSalesCustomerTypes.RESTORE_INITIAL
}
const repSalesCategoryErrorConfig = {
  reducer: "reportSalesCategory",
  restoreKey: reportSalesCategoryTypes.RESTORE_INITIAL
}
const repSupervisionErrorConfig = {
  reducer: "reportSupervision",
  restoreKey: reportSupervisionTypes.RESTORE_INITIAL
}
const repResumeDayErrorConfig = {
  reducer: "reportResumeDay",
  restoreKey: reportResumeDayTypes.RESTORE_INITIAL
}
const repDepositsErrorConfig = {
  reducer: "reportDeposits",
  restoreKey: reportDepositsTypes.RESTORE_INITIAL
}
const repInvoiceListErrorConfig = {
  reducer: "reportInvoiceList",
  restoreKey: reportInvoiceListTypes.RESTORE_INITIAL
}
const repInvoiceRelationshipErrorConfig = {
  reducer: "reportInvoiceRelationship",
  restoreKey: reportInvoiceRelationshipTypes.RESTORE_INITIAL
}
const repGlobalSalesErrorConfig = {
  reducer: "reportGlobalSales",
  restoreKey: reportGlobalSalesTypes.RESTORE_INITIAL
}
const repCashReconciliationErrorConfig = {
  reducer: "reportCashReconciliation",
  restoreKey: reportCashReconciliationTypes.RESTORE_INITIAL,
}
const repSalesCumulativeGlobalErrorConfig = {
  reducer: "reportSalesCumulativeGlobal",
  restoreKey: reportSalesCumulativeGlobalTypes.RESTORE_INITIAL
}
const repNationalNotesErrorConfig = {
  reducer: "reportNationalNotes",
  restoreKey: reportNationalNotesTypes.RESTORE_INITIAL,
}
const repDigitalInventoryErrorConfig = {
  reducer: "reportDigitalInventory",
  restoreKey: reportDigitalInventoryTypes.RESTORE_INITIAL
}

export const reportRoutes = [
  {
    collapse: true,
    name: "Reportes",
    icon: AssessmentIcon,
    state: "reportsSection",
    inSidebar: true,
    isProtected: true,
    rule: REPORTS,
    views: [
      {
        path: "/reportes",
        name: "Reportes Gastos",
        mini: "RG",
        component: ReportPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_EXPENSES,
      },
      {
        path: "/logins_reportes",
        name: "Reportes Logins",
        mini: "RL",
        component: LogsReportPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_LOGINS,
      },
      {
        path: "/report_advance_payments_report",
        name: "Reporte Anticipos",
        mini: "RAP",
        component: ReportAdvancePaymentsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_ADVANCE_PAYMENTS,
        reducer: "reportAdvancePayments",
        restoreKey: reportAdvancePaymentsTypes.RESTORE_INITIAL
      },
      {
        path: "/supervision_report",
        name: "Reporte Supervisión",
        mini: "RS",
        component: ReportSupervisionView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SUPERVISION,
        ...repSupervisionErrorConfig
      },
      {
        path: "/carburetion_report",
        name: "Reporte Carburación",
        mini: "RC",
        component: ReportCarburetionView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_CARBURATION,
        ...repCarburetionErrorConfig
      },
      {
        path: "/carburetion3_report",
        name: "Reporte Carburación 3",
        mini: "RC3",
        component: ReportCarburetion3View,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_CARBURETION3,
        reducer: "reportCarburetion3",
        restoreKey: reportCarburetion3Types.RESTORE_INITIAL
      },
      {
        path: "/cash_reconciliation_report",
        name: "Reporte Corte de Caja",
        mini: "RL",
        component: ReportCashReconciliationView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_CASH_RECONCILIATION,
        ...repCashReconciliationErrorConfig
      },
      {
        path: "/inventories_report",
        name: "Reporte Inventarios",
        mini: "RI",
        component: ReportInventoriesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_INVENTORY,
        ...repInventoriesErrorConfig,
      },
      {
        path: "/inventory_stock_report",
        name: "Reporte Existencias de Inv.",
        mini: "RIS",
        component: ReportInventoryStockView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_INVENTORY_STOCK,
        reducer: "reportInventoryStock",
        restoreKey: reportInventoryStockTypes.RESTORE_INITIAL
      },
      {
        path: "/inventories_report_day",
        name: "Reporte Inventario día",
        mini: "RID",
        component: ReportInventoriesDayView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_DETAIL_INVENTORY,
        ...repInventoriesErrorConfig
      },
      {
        path: "/day_report",
        name: "Reporte del Día",
        mini: "RD",
        component: ReportDayView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_DAY_GN4,
        ...repDayErrorConfig,
      },
      {
        path: "/day_resume_report",
        name: "Reporte Resumen Día",
        mini: "RR",
        component: ReportResumeDayView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_RESUME_DAY,
        ...repResumeDayErrorConfig,
      },
      {
        path: "/gas_movements_report",
        name: "Reporte Bonificación de gas",
        mini: "RM",
        component: ReportGasMovementsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_BONIFICATIONS,
        ...repGasMovementsErrorConfig,
      },
      {
        path: "/detailed_notes_report",
        name: "Reporte Detallado Notas",
        mini: "D",
        component: ReportDetailedNotesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_DETAILED_NOTES,
        reducer: "reportDetailedNotes",
        restoreKey: reportDetailedNotesTypes.RESTORE_INITIAL
      },
      {
        path: "/discounts_relationship_report",
        name: "Reporte Relación Descuento",
        mini: "D",
        component: ReportDiscountsRelationshipView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_DISCOUNTS_RELATIONSHIP,
        reducer: "reportDiscountsRelationship",
        restoreKey: reportDiscountsRelationshipTypes.RESTORE_INITIAL
      },
      {
        path: "/sales_report_unit",
        name: "Reporte Venta unidad",
        mini: "RS",
        component: ReportSalesUnitView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES,
        ...repSalesErrorConfig,
      },
      {
        path: "/sales_report_zone",
        name: "Reporte Venta por zona",
        mini: "RS",
        component: ReportSalesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES,
        ...repSalesErrorConfig
      },
      {
        path: "/sales_report_category",
        name: "Reporte Venta por Categoría",
        mini: "RS",
        component: ReportSalesCategoryView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES_CATEGORY,
        ...repSalesCategoryErrorConfig
      },
      {
        path: "/sales_report_customer",
        name: "Reporte Venta por Cliente",
        mini: "RV",
        component: ReportSalesCustomerView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES_CUSTOMER,
        ...repSalesCustomerErrorConfig
      },
      {
        path: "/sales_by_note_report",
        name: "Reporte Ventas por Nota",
        mini: "RSN",
        component: ReportSalesByNoteView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES_BY_NOTE,
        reducer: "reportSalesByNote",
        restoreKey: reportSalesByNoteTypes.RESTORE_INITIAL
      },
      {
        path: "/sale_by_municipality_report",
        name: "Reporte Venta por Mpio.",
        mini: "VM",
        component: ReportSaleByMunicipalityView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SALE_BY_MUNICIPALITY,
        reducer: "reportSaleByMunicipality",
        restoreKey: reportSaleByMunicipalityTypes.RESTORE_INITIAL
      },
      {
        path: "/sales_by_zone_wholesaler_report",
        name: "Reporte Venta zona Mayoris.",
        mini: "RVM",
        component: ReportSalesByZoneWholesalerView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SALES_BY_ZONE_WHOLESALER,
        reducer: "reportSalesByZoneWholesaler",
        restoreKey: reportSalesByZoneWholesalerTypes.RESTORE_INITIAL
      },
      {
        path: "/credit_report",
        name: "Reporte Crédito",
        mini: "RC",
        component: ReportCreditView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_CREDIT,
      },
      {
        path: "/notes_transferred_report",
        name: "Reporte Notas Traspasadas",
        mini: "RN",
        component: ReportNotesTransferredView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_CREDIT_MIGRATION,
      },
      {
        path: "/corporate_shipment_report",
        name: "Reporte Embarque Corp.",
        mini: "RE",
        component: ReportCorporateShipmentsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SHIPMENTS,
      },
      {
        path: "/global_sales_report",
        name: "Reporte Venta Global",
        mini: "RV",
        component: ReportGlobalSalesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_GLOBAL_SALES,
        ...repGlobalSalesErrorConfig,
      },
      {
        path: "/como_data_report",
        name: "Reporte Comodatos",
        mini: "RS",
        component: ReportComoDataView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_COMODATA,
        ...repComoDataErrorConfig,
      },
      {
        path: "/deposits_report",
        name: "Reporte Depósitos",
        mini: "RD",
        component: ReportDepositsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_DEPOSITS,
        ...repDepositsErrorConfig,
      },
      {
        path: "/invoice_list_report",
        name: "Reporte Listado Facturación",
        mini: "RF",
        component: ReportInvoiceListView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_INVOICE_LIST,
        ...repInvoiceListErrorConfig,
      },
      {
        path: "/invoice_resume_report",
        name: "Reporte Facturación Notas",
        mini: "RRF",
        component: ReportInvoiceRelationshipView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_INVOICE_RELATIONSHIP,
        ...repInvoiceRelationshipErrorConfig,
      },
      {
        path: "/transfer_invoice_report",
        name: "Reporte Facturas Traslado",
        mini: "RFT",
        component: ReportTransferInvoiceView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_TRANSFER_INVOICE,
        reducer: "reportTransferInvoice",
        restoreKey: reportTransferInvoiceTypes.RESTORE_INITIAL,
      },
      {
        path: "/sales_cumulative_global_report",
        name: "Reporte Venta Global Acum.",
        mini: "RVA",
        component: ReportSalesCumulativeGlobalView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_SALES_CUMULATIVE_GLOBAL,
        ...repSalesCumulativeGlobalErrorConfig,
      },
      {
        path: "/national_notes_report",
        name: "Reporte Notas Nacionales",
        mini: "RNN",
        component: ReportNationalNotesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_NATIONAL_NOTES,
        ...repNationalNotesErrorConfig,
      },
      {
        path: "/digital_inventory_report",
        name: "Reporte Inventario Digital",
        mini: "RI",
        component: ReportDigitalInventoryView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_DIGITAL_INVENTORY,
        ...repDigitalInventoryErrorConfig
      },
      {
        path: "/rapidcanvas_dashboard",
        name: "Dashboard Distribución",
        mini: "DD",
        component: ReportRapidCanvasView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: REPORTS_RAPIDCANVAS
      },
      {
        path: "/shipments_performance_report",
        name: "Reporte Rend. Embarque",
        mini: "RRE",
        component: ReportShipmentsPerformanceView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SHIPMENTS_PERFORMANCE,
        reducer: "reportShipmentsPerformance",
        restoreKey: reportShipmentsPerformanceTypes.RESTORE_INITIAL
      },
      {
        path: "/substitution_settlements_report",
        name: "Reporte Sust. Liquidaciones",
        mini: "S",
        component: ReportSubstitutionSettlementsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SUBSTITUTION_SETTLEMENTS,
        reducer: "reportSubstitutionSettlements",
        restoreKey: reportSubstitutionSettlementsTypes.RESTORE_INITIAL
      },
      {
        path: "/retentions_report",
        name: "Reporte Retenciones",
        mini: "R",
        component: ReportRetentionsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_RETENTIONS,
        reducer: "reportRetentions",
        restoreKey: reportRetentionsTypes.RESTORE_INITIAL
      },
      {
        path: "/retentions_exists_report",
        name: "Reporte Salidas Retenciones",
        mini: "R",
        component: ReportRetentionsExistsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_RETENTIONS_EXISTS,
        reducer: "reportRetentionsExists",
        restoreKey: reportRetentionsExistsTypes.RESTORE_INITIAL
      },
      {
        path: "/special_units_report",
        name: "Reporte Unidades Especiales",
        mini: "S",
        component: ReportSpecialUnitsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SPECIAL_UNITS,
        reducer: "reportSpecialUnits",
        restoreKey: reportSpecialUnitsTypes.RESTORE_INITIAL
      },
      {
        path: "/shipments_returns_report",
        name: "Reporte Dev. Embarque",
        mini: "RSR",
        component: ReportShipmentsReturnsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SHIPMENTS_RETURNS,
        reducer: "reportShipmentsReturns",
        restoreKey: reportShipmentsReturnsTypes.RESTORE_INITIAL
      },
      {
        path: "/unit_performance_report",
        name: "Reporte Rend. Unidades",
        mini: "RU",
        component: ReportUnitPerformanceView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_UNIT_PERFORMANCE,
        reducer: "reportUnitPerformance",
        restoreKey: reportUnitPerformanceTypes.RESTORE_INITIAL
      },
      {
        path: "/units_with_permission_report",
        name: "Reporte Unidades Permiso",
        mini: "UP",
        component: ReportUnitsWithPermissionView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_UNITS_WITH_PERMISSION,
        reducer: "reportUnitsWithPermission",
        restoreKey: reportUnitsWithPermissionTypes.RESTORE_INITIAL
      },
      {
        path: "/accumulated_discount_report",
        name: "Reporte Desc. Acumulados",
        mini: "DA",
        component: ReportAccumulatedDiscountView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_ACCUMULATED_DISCOUNT,
        reducer: "reportAccumulatedDiscount",
        restoreKey: reportAccumulatedDiscountTypes.RESTORE_INITIAL
      },
      {
        path: "/audit_settlements_report",
        name: "Reporte Liquidaciones Audit.",
        mini: "RLA",
        component: ReportAuditSettlementsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_AUDIT_SETTLEMENTS,
        reducer: "reportAuditSettlements",
        restoreKey: reportAuditSettlementsTypes.RESTORE_INITIAL,
      },
      {
        path: "/settlements_report",
        name: "Reporte Liquidaciones",
        mini: "RLQ",
        component: ReportSettlementsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_SETTLEMENTS,
        reducer: "reportSettlements",
        restoreKey: reportSettlementsTypes.RESTORE_INITIAL,
      },
      {
        path: "/cash_discount_customers_report",
        name: "Reporte Clientes Cont. Desc.",
        mini: "RCD",
        component: ReportCashDiscountCustomersView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_CASH_DISCOUNT_CUSTOMERS,
        reducer: "reportCashDiscountCustomers",
        restoreKey: reportCashDiscountCustomersTypes.RESTORE_INITIAL,
      },
      {
        path: "/progressive_app_report",
        name: "Reporte App Progresivo",
        mini: "RAP",
        component: ReportProgressiveAppView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_PROGRESSIVE_APP,
        reducer: "reportProgressiveApp",
        restoreKey: reportProgressiveAppTypes.RESTORE_INITIAL,
      },
      {
        path: "/inventory_percentages_report",
        name: "Reporte Porc. de Inventario",
        mini: "RPI",
        component: ReportInventoryPercentagesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_INVENTORY_PERCENTAGES,
        reducer: "reportInventoryPercentages",
        restoreKey: reportInventoryPercentagesTypes.RESTORE_INITIAL
      },
      {
        path: "/invoices_grouped_report",
        name: "Reporte Agrupación Fact.",
        mini: "RIG",
        component: ReportInvoicesGroupedView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.REPORTS_INVOICES_GROUPED,
        reducer: "reportInvoicesGrouped",
        restoreKey: reportInvoicesGroupedTypes.RESTORE_INITIAL
      },
    ],
  },
]
